import React from "react";

const HandLens = () => {
  return (
    <svg
      className="hand-lens"
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 44.47 44.47"
    >
      <title>HandLens</title>
      <circle className="cls-1" cx="19.5" cy="19.5" r="17.5" />
      <path
        className="cls-2"
        d="M2069.27,1340.7a9.91,9.91,0,0,1,9.91,9.91"
        transform="withTranslation(-2049.77 -1331.1)"
      />
      <line className="cls-1" x1="31.82" y1="31.82" x2="43.06" y2="43.06" />
    </svg>
  );
};

export default HandLens;
